/**
 * @desc 同步亚马逊店铺
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.Response;
export function request(options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/basics/platformShop/syncAmazonShop`, {
      method: "POST",

      ...options,
    }),
  );
}
